import { ProgressGradient } from "antd/es/progress/progress";
import classNames from "classnames";
import { Progress } from "antd";
import styles from "./style.module.scss";

export interface ProgressBarBaseProps {
  strokeColor?: string | string[] | ProgressGradient | "danger";
  fillPercent: number;
  isActive?: boolean;
  type?: "primary" | "default";
}

export default function ProgressBase({
  type = "default",
  strokeColor,
  fillPercent,
  isActive,
}: ProgressBarBaseProps) {
  const status = isActive ? "active" : "normal";

  const progressClassnames = classNames(styles.progress, {
    [styles.defaultProgress]: !strokeColor,
    [styles.primarySizeProgress]: type === "primary",
  });

  return (
    <Progress
      className={progressClassnames}
      strokeColor={strokeColor}
      percent={fillPercent}
      showInfo={false}
      status={status}
    />
  );
}
